const niche = [
  {
    id: 1,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651864/KWP_0308_tiiloo.jpg",
    topic: "HILDA FOR JOS PHOTO MAGAZINE 2024",
    niche: "Fashion | Styling | Color",
    date: "July, 2024",
    link: "",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651942/KWP_6639_ahfmtc.jpg",
    topic: "BYENCHIT FASHION AND RUNWAY MODEL FOR ONAZI CLOTHINGS",
    niche: "Fashion | Styling | Color",
    date: "September 2024",
    link: "",
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740514540/WhatsApp_Image_2025-02-24_at_19.08.05_dktemd.jpg",
    topic: "BYENCHIT FASHION AND RUNWAY MODEL FOR ONAZI CLOTHINGS",
    niche: "Fashion | Styling | Color",
    date: "January 2025",
    link: "",
  },
  {
    id: 4,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652059/photo14_jqns6j.jpg",
    topic: "SIZA ALPHA FASHION INFLUENCER IN DENIM",
    niche: "Fashion | Styling | Color",
    date: "April 2024",
    link: "",
  },
  {
    id: 5,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652054/photo20_mptsgh.jpg",
    topic: "SIZA ALPHA FASHION INFLUENCER IN DENIM",
    niche: "Fashion | Styling | Color",
    date: "April 2024",
    link: "",
  },
  {
    id: 6,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651918/KWP_4563_t6bhni.jpg",
    topic: "NATE FASHION INFLUENCER",
    niche: "Fashion | Styling | Color",
    date: "February 2024",
    link: "",
  },
  {
    id: 7,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651921/KWP_4584_eb5d86.jpg",
    topic: "SIZA ALPHA FASHION INFLUENCER",
    niche: "Fashion | Styling | Color",
    date: "March 2024",
    link: "",
  },
  {
    id: 8,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651956/KWP_5980_qok64u.jpg",
    topic: "HOPE FASHION AND RUNWAY MODEL FOR RJ'S COLLECTION",
    niche: "Fashion | Styling | Color",
    date: "October 2024",
    link: "",
  },
  {
    id: 9,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652047/photo12_dclhis.jpg",
    topic: "RITMWA FOR JOS PHOTO MAGAZINE 2024",
    niche: "Fashion | Styling | Color",
    date: "July, 2024",
    link: "",
  },
  {
    id: 10,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739656506/KWP_7078_kosdpq.jpg",
    topic: "EBUKA FOR ONAZI CLOTHING",
    niche: "Fashion | Styling | Color",
    date: "September 2024",
    link: "",
  },
  {
    id: 11,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1740514540/WhatsApp_Image_2025-02-24_at_19.08.12_cb761f.jpg",
    topic: "THE WEAL",
    niche: "Fashion | Styling | Color",
    date: "January 2025",
    link: "",
  },
  {
    id: 12,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652044/KWP_9773_nsa6ae.jpg",
    topic: "RITMWA FASHION MODEL",
    niche: "Fashion | Styling | Color",
    date: "July 2024",
    link: "",
  },

  {
    id: 13,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651927/KWP_4431_qsdf7b.jpg",
    topic: "MIKE WILLS FOR QUAN IMAGERY",
    niche: "Fashion | Styling | Color",
    date: "February 2024",
    link: "",
  },
  {
    id: 14,
    img: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739656133/KWP_0435_icwvdl.jpg",
    topic: "NATE FOR ZZ LUXURY 2024",
    niche: "Fashion | Styling | Color",
    date: "September 2024",
    link: "",
  },
];

export default niche;
